"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _ = require("../");

var _excluded = ["defaultValue"],
    _excluded2 = ["keepCharPositions", "placeholderChar", "mask", "placeholder"];

var MaskedInput = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_reactTextMask["default"], (0, _extends2["default"])({}, props, {
    ref: ref,
    render: function render(ref, _ref) {
      var defaultValue = _ref.defaultValue,
          props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_.Input, (0, _extends2["default"])({
        ref: ref,
        value: defaultValue
      }, props));
    }
  }));
});

MaskedInput.displayName = 'MaskedInput';
var TimeInput = ( /*#__PURE__*/0, _styledBase["default"])(function (_ref2) {
  var _ref2$keepCharPositio = _ref2.keepCharPositions,
      keepCharPositions = _ref2$keepCharPositio === void 0 ? true : _ref2$keepCharPositio,
      _ref2$placeholderChar = _ref2.placeholderChar,
      placeholderChar = _ref2$placeholderChar === void 0 ? "\u2000" : _ref2$placeholderChar,
      _ref2$mask = _ref2.mask,
      mask = _ref2$mask === void 0 ? [/[0-2]/, /[0-9]/, ':', /[0-6]/, /[0-9]/, ' AEST'] : _ref2$mask,
      _ref2$placeholder = _ref2.placeholder,
      placeholder = _ref2$placeholder === void 0 ? '00:00 AEST' : _ref2$placeholder,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(MaskedInput, (0, _extends2["default"])({
    keepCharPositions: keepCharPositions,
    placeholderChar: placeholderChar,
    mask: mask,
    placeholder: placeholder
  }, props));
}, {
  target: "e41ycu60",
  label: "TimeInput"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01hc2tlZElucHV0L01hc2tlZElucHV0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtDQyIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9NYXNrZWRJbnB1dC9NYXNrZWRJbnB1dC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgVGV4dE1hc2sgZnJvbSAncmVhY3QtdGV4dC1tYXNrJztcblxuaW1wb3J0IHsgSW5wdXQgfSBmcm9tICcuLi8nO1xuXG5jb25zdCBNYXNrZWRJbnB1dCA9IFJlYWN0LmZvcndhcmRSZWYoKHByb3BzLCByZWYpID0+IChcbiAgPFRleHRNYXNrXG4gICAgey4uLnByb3BzfVxuICAgIHJlZj17cmVmfVxuICAgIHJlbmRlcj17KHJlZiwgeyBkZWZhdWx0VmFsdWUsIC4uLnByb3BzIH0pID0+IChcbiAgICAgIDxJbnB1dCByZWY9e3JlZn0gdmFsdWU9e2RlZmF1bHRWYWx1ZX0gey4uLnByb3BzfSAvPlxuICAgICl9XG4gIC8+XG4pKTtcblxuTWFza2VkSW5wdXQuZGlzcGxheU5hbWUgPSAnTWFza2VkSW5wdXQnO1xuXG5jb25zdCBUaW1lSW5wdXQgPSBzdHlsZWQoXG4gICh7XG4gICAga2VlcENoYXJQb3NpdGlvbnMgPSB0cnVlLFxuICAgIHBsYWNlaG9sZGVyQ2hhciA9ICdcXHUyMDAwJyxcbiAgICBtYXNrID0gWy9bMC0yXS8sIC9bMC05XS8sICc6JywgL1swLTZdLywgL1swLTldLywgJyBBRVNUJ10sXG4gICAgcGxhY2Vob2xkZXIgPSAnMDA6MDAgQUVTVCcsXG4gICAgLi4ucHJvcHNcbiAgfSkgPT4gKFxuICAgIDxNYXNrZWRJbnB1dFxuICAgICAga2VlcENoYXJQb3NpdGlvbnM9e2tlZXBDaGFyUG9zaXRpb25zfVxuICAgICAgcGxhY2Vob2xkZXJDaGFyPXtwbGFjZWhvbGRlckNoYXJ9XG4gICAgICBtYXNrPXttYXNrfVxuICAgICAgcGxhY2Vob2xkZXI9e3BsYWNlaG9sZGVyfVxuICAgICAgey4uLnByb3BzfVxuICAgIC8+XG4gICksXG4pYGA7XG5UaW1lSW5wdXQuZGlzcGxheU5hbWUgPSAnTWFza2VkSW5wdXQudGltZSc7XG5cbk1hc2tlZElucHV0LnRpbWUgPSBUaW1lSW5wdXQ7XG5cbmV4cG9ydCBkZWZhdWx0IE1hc2tlZElucHV0O1xuIl19 */");
TimeInput.displayName = 'MaskedInput.time';
MaskedInput.time = TimeInput;
var _default = MaskedInput;
exports["default"] = _default;